import React from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "@tecma/i18n";
import { Button } from "@tecma/ds";

import { applicationStateSelectors } from "store/slices/applicationState/selectors";

import "./contact-section.scss";

interface ContactSectionRequiredProps {
  onClick: () => void;
}

// Optional Props

const ContactSection: React.FC<ContactSectionRequiredProps> = ({ onClick }) => {
  const { t } = useTranslation();
  const displayName = useSelector(applicationStateSelectors.displayName);

  return (
    <div className='contact-section'>
      <h3>{displayName}</h3>
      <span>{t("details-page.contact-section")}</span>
      <Button onClick={onClick} outlined>
        {t("contact-us-modal.title")}
      </Button>
    </div>
  );
};

export default React.memo(ContactSection);
